import { GUID_REGEX } from "../contexts/ScannerContext";

/**
 * The part id carried by a scan, or null when the barcode wasn't a part label.
 * Part labels scan as "p|{partId}|{tag}"; older labels are a bare GUID.
 */
export function partIdFromScan(parts: string[]): string | null {
  if (!parts || parts.length === 0) return null;

  if (parts.length === 1 && GUID_REGEX.test(parts[0])) return parts[0];

  if (parts[0]?.toLowerCase() === "p") {
    const id = parts[1]?.trim();
    return id && GUID_REGEX.test(id) ? id : null;
  }

  return null;
}

/** True when the scan was a part label, even if the id itself was unreadable. */
export function isPartScan(parts: string[]): boolean {
  if (!parts || parts.length === 0) return false;
  return parts[0]?.toLowerCase() === "p" || (parts.length === 1 && GUID_REGEX.test(parts[0]));
}
